import { Component, OnDestroy, OnInit } from '@angular/core';
import { UsersService } from '../users/users.service';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  saveAction: any;
  saveEnabled: boolean = false;
  navigationAction: any;
  navigationEnabled: boolean = false;
  footerEnabled: boolean = false;
  headerHidden: boolean = false;
  // private profileSubscription: Subscription;

  constructor(private usersService: UsersService) { }

  ngOnInit() {
    // Keeping this here for easy reference for future banners toggled on user profile
    // this.profileSubscription = this.usersService.profile$.subscribe((profile) => {
    // });
  }

  onActivate(component) {
    if (component.canSave != null) {
      component.canSave.subscribe((event: {enabled: boolean, action?: any}) => {
        this.saveEnabled = event.enabled;
        this.saveAction = event.action;
      })
    }
    if (component.canNavigate != null) {
      component.canNavigate.subscribe((event: {enabled: boolean, action?: any}) => {
        this.navigationEnabled = event.enabled;
        this.navigationAction = event.action;
      })
    }
    if (component.hasFooter == true) {
      this.footerEnabled = true;
    }
    if (component.headerHiddenChanged != null) {
      component.headerHiddenChanged.subscribe((event: {hidden: boolean}) => {
        this.headerHidden = event.hidden;
      })
    }
  }

  onDeactivate(component) {
    this.saveEnabled = false;
    this.saveAction = null;
    this.navigationEnabled = false;
    this.navigationAction = null;
    this.footerEnabled = false;
    this.headerHidden = false;
  }

  ngOnDestroy() {
    // Keeping this here for easy reference for future banners toggled on user profile
    // if (this.profileSubscription) {
    //   this.profileSubscription.unsubscribe();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/layout.component.ts